import React, { ReactElement, useMemo } from 'react'
import { ColorMap, getJepColor } from '@/components/static/ui/consts'
import { useShouldStackImagesAndBullets } from '@/hooks/useShouldStackImagesAndBullets'
import { BasePageProps } from '@/globals/pages.types'
import { CourseConfigType } from 'common/src/courseConfig'
import { GetStaticProps } from 'next'
import { TipsGuidePage } from '@/components/static/StudyMaterialsGuidePage/GuideComponents/General/TipsGuidePage'

// TODO: Should gather the necessary data to populate this page via some kind of config
export const getStaticProps = (async (_context) => {
    return { props: { courseConfigType: CourseConfigType.fsaHealth } }
}) satisfies GetStaticProps<BasePageProps>

const Page = (props: BasePageProps): ReactElement => {
    const shouldStackImagesAndBullets = useShouldStackImagesAndBullets()
    const color = useMemo((): ColorMap => {
        return getJepColor(props.courseConfigType)
    }, [props.courseConfigType])
    return (
        <TipsGuidePage
            shouldStackImagesAndBullets={shouldStackImagesAndBullets}
            isLoggedIn={false}
            {...props}
        />
    )
}

Page.isStatic = true

export default Page
